import type { UserConnexionResponse } from "@api/src/types/responses";
import API from "@app/services/api";
import useUser from "@app/zustand/user";
import { usePreviewView } from "@app/zustand/preview-view";

export const DEMO_USER_EMAIL = "demo@mage-x.com";

/** True for the demo account only — never for a real doctor. */
export function isDemoEmail(email: string | null | undefined): boolean {
  return email === DEMO_USER_EMAIL;
}

/** A user visiting the demo, who can go back to their own account. */
export function hasDemoReturn(user: unknown): boolean {
  return (user as { demo_return?: boolean } | null)?.demo_return === true;
}

/**
 * Switches the session into the demo (`enter`) or back to their own account (`leave`), then
 * reloads on the home page so nothing of the previous account stays on screen. False when refused.
 */
export async function switchDemoSession(
  direction: "enter" | "leave",
): Promise<boolean> {
  const res = (await API.post({
    path: `/user/demo/${direction}`,
  })) as UserConnexionResponse;
  if (!res?.ok || !res.data?.user) return false;
  useUser.getState().setUser(res.data.user);
  // A preview belongs to the account that set it.
  usePreviewView.getState().setPreview(null);
  window.location.assign("/");
  return true;
}
